/** Rótulos em português dos eventos do iFood (log, régua da entrega, simulador). */
export const EVENT_LABELS = {
  PLACED: "Pedido recebido", PLC: "Pedido recebido",
  CONFIRMED: "Confirmado", CFM: "Confirmado",
  PREPARATION_STARTED: "Preparo iniciado", PRS: "Preparo iniciado",
  READY_TO_PICKUP: "Pronto", RTP: "Pronto",
  DISPATCHED: "Saiu para entrega", DSP: "Saiu para entrega",
  ASSIGN_DRIVER: "Entregador atribuído", ADR: "Entregador atribuído",
  GOING_TO_ORIGIN: "Entregador a caminho da loja", GTO: "Entregador a caminho da loja",
  ARRIVED_AT_ORIGIN: "Entregador chegou na loja", AAO: "Entregador chegou na loja",
  COLLECTED: "Pedido coletado", CLT: "Pedido coletado",
  ARRIVED_AT_DESTINATION: "Entregador chegou no cliente", AAD: "Entregador chegou no cliente",
  DELIVERY_DRIVER_DEALLOCATED: "Entregador desalocado",
  DELIVERY_DROP_CODE_REQUESTED: "Código de entrega exigido", DDCR: "Código de entrega exigido",
  DELIVERY_PICKUP_CODE_REQUESTED: "Código de coleta exigido",
  DELIVERY_PICKUP_CODE_VALIDATION_SUCCESS: "Código de coleta validado",
  CONCLUDED: "Concluído", CON: "Concluído",
  CANCELLED: "Cancelado", CAN: "Cancelado",
  CANCELLATION_REQUESTED: "Cancelamento solicitado", CAR: "Cancelamento solicitado",
  CANCELLATION_REQUEST_FAILED: "Cancelamento negado pelo iFood", CARF: "Cancelamento negado pelo iFood",
  HANDSHAKE_DISPUTE: "Negociação aberta pelo cliente", HSD: "Negociação aberta pelo cliente",
  HANDSHAKE_SETTLEMENT: "Negociação encerrada", HSS: "Negociação encerrada",
  ORDER_PATCHED: "Pedido alterado", OPA: "Pedido alterado",
  RECOMMENDED_PREPARATION_START: "Hora recomendada de iniciar o preparo", RPS: "Hora recomendada de iniciar o preparo",
  KEEPALIVE: "Keep-alive",
};

export const EVENT_TONE = {
  PLACED: "text-amber-600 dark:text-amber-400", PLC: "text-amber-600 dark:text-amber-400",
  CONFIRMED: "text-blue-600 dark:text-blue-400", CFM: "text-blue-600 dark:text-blue-400",
  READY_TO_PICKUP: "text-green-600 dark:text-green-400", RTP: "text-green-600 dark:text-green-400",
  DISPATCHED: "text-purple-600 dark:text-purple-400", DSP: "text-purple-600 dark:text-purple-400",
  CONCLUDED: "text-muted-foreground", CON: "text-muted-foreground",
  CANCELLED: "text-red-600 dark:text-red-400", CAN: "text-red-600 dark:text-red-400",
  HANDSHAKE_DISPUTE: "text-orange-600 dark:text-orange-400", HSD: "text-orange-600 dark:text-orange-400",
};

/** Etapa do entregador do iFood guardada em `ifood_meta.delivery_stage`. */
export const DELIVERY_STAGE_LABELS = {
  GOING_TO_ORIGIN: "Entregador iFood a caminho da loja",
  ARRIVED_AT_ORIGIN: "Entregador iFood chegou na loja",
  COLLECTED: "Entregador iFood coletou o pedido",
  ARRIVED_AT_DESTINATION: "Entregador iFood chegou no cliente",
  DRIVER_DEALLOCATED: "iFood ainda vai alocar outro entregador",
};

export function eventLabel(code) {
  return EVENT_LABELS[code] || code;
}

/** Grupo visual do evento → cor da linha na tela Eventos. */
export function eventGroup(code) {
  const c = String(code || "").toUpperCase();
  if (["PLACED", "PLC"].includes(c)) return "novo";
  if (["CONFIRMED", "CFM", "PREPARATION_STARTED", "PRS"].includes(c)) return "aceito";
  if (["READY_TO_PICKUP", "RTP"].includes(c)) return "pronto";
  if (["DISPATCHED", "DSP", "ASSIGN_DRIVER", "ADR", "GOING_TO_ORIGIN", "GTO", "ARRIVED_AT_ORIGIN", "AAO", "COLLECTED", "CLT", "ARRIVED_AT_DESTINATION", "AAD", "DELIVERY_DRIVER_DEALLOCATED"].includes(c)) return "entrega";
  if (["CONCLUDED", "CON"].includes(c)) return "concluido";
  if (c.startsWith("CANCEL") || c === "CAN" || c === "CAR" || c === "CARF") return "cancelado";
  if (c.startsWith("HANDSHAKE") || c === "HSD" || c === "HSS") return "negociacao";
  if (c.includes("CODE")) return "codigo";
  return "outro";
}

export const GROUP_STYLE = {
  novo:       { row: "border-l-amber-500 bg-amber-500/[0.06]",     dot: "bg-amber-500",   text: "text-amber-700 dark:text-amber-400",    label: "Novo pedido" },
  aceito:     { row: "border-l-blue-500 bg-blue-500/[0.05]",       dot: "bg-blue-500",    text: "text-blue-700 dark:text-blue-400",      label: "Aceite" },
  pronto:     { row: "border-l-green-500 bg-green-500/[0.05]",     dot: "bg-green-500",   text: "text-green-700 dark:text-green-400",    label: "Pronto" },
  entrega:    { row: "border-l-purple-500 bg-purple-500/[0.05]",   dot: "bg-purple-500",  text: "text-purple-700 dark:text-purple-400",  label: "Entrega" },
  concluido:  { row: "border-l-emerald-600 bg-emerald-500/[0.05]", dot: "bg-emerald-600", text: "text-emerald-700 dark:text-emerald-400", label: "Concluído" },
  cancelado:  { row: "border-l-red-500 bg-red-500/[0.06]",         dot: "bg-red-500",     text: "text-red-700 dark:text-red-400",        label: "Cancelamento" },
  negociacao: { row: "border-l-orange-500 bg-orange-500/[0.07]",   dot: "bg-orange-500",  text: "text-orange-700 dark:text-orange-400",  label: "Negociação" },
  codigo:     { row: "border-l-slate-500 bg-slate-500/[0.05]",     dot: "bg-slate-500",   text: "text-slate-700 dark:text-slate-300",    label: "Códigos" },
  outro:      { row: "border-l-border",                            dot: "bg-muted-foreground/50", text: "text-muted-foreground",          label: "Outros" },
};
